import React from 'react';
import classes from './style.module.css'
import Aux from 'react-aux'

const TimeTick = props => {

    let tickBox = null
    if(props.value !== "" && props.value > 0 ) tickBox = <div className={classes.TimeTick}>
            {props.value}
    </div>

   return (
       <Aux>
       {tickBox}
       </Aux>
   );
}

export default TimeTick;